import React, { useState, useEffect } from 'react';

interface FlipTextProps {
  dataList: string[];
  style?: React.CSSProperties;
  className?: string;
  tick?: number;
}

const FlipText: React.FC<FlipTextProps> = ({ dataList, className, tick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [items, setItems] = useState<string[]>([]);

  useEffect(() => {
    setItems(dataList.map(item => item));
  }, [dataList]);

  // External tick mode (synchronized)
  useEffect(() => {
    if (tick === undefined || items.length <= 1) return;
    setCurrentIndex(tick % items.length);
    setIsAnimating(true);
    const timeout = setTimeout(() => setIsAnimating(false), 600);
    return () => clearTimeout(timeout);
  }, [tick]);

  // Internal interval mode (fallback when no tick prop)
  useEffect(() => {
    if (tick !== undefined) return;
    if (items.length <= 1) return;

    const interval = setInterval(() => {
      setIsAnimating(true);
      setCurrentIndex((prev) => (prev + 1) % items.length);
      setTimeout(() => setIsAnimating(false), 600);
    }, 5000);

    return () => clearInterval(interval);
  }, [items.length, tick]);

  return (
    <div  className="design2-flip-container">
      <div  className={`design2-flip-item ${isAnimating ? 'animate-flip' : ''}`}>
        <h2 style={{fontWeight:'bold', color:'var(--flip-text-color, #FFFACC)'}} className={className}>{items[currentIndex]?.toString()?.toUpperCase()}</h2>
      </div>
    </div>
  );
};

export default FlipText;
